import { Window } from '@progress/kendo-react-dialogs';

interface MetadataSectionProps {
    onClose: () => void;
    metaData: any;
  }

export function MetadataSection({onClose, metaData}: MetadataSectionProps){
    return (
      <Window 
        title="External Metadata" 
        onClose={onClose} 
        modal={true} 
        maximizeButton={() => null} 
        minimizeButton={() => null} 
        doubleClickStageChange={false}
        resizable={false} 
        style={{
          height: 'fit-content',
          width: '400px',
          maxHeight: '500px',
          overflow: 'auto',
        }}>
        <JsonViewer json={metaData} />
      </Window>
    );
};

const JsonViewer = ({ json }: { json: any }) => {
  if (!json || (typeof json === 'object' && Object.keys(json).length === 0)) {
    return (
      <pre className="jsonViewer">
        <em>No external metadata linked to this annotation available to display.</em>
      </pre>
    );
  }

  let jsonString = '';

  try {
    jsonString = JSON.stringify(json, null, 2);
  } catch {
    return (
      <pre className="jsonViewer" style={{ color: 'red', fontWeight: 'bold' }}>
        Invalid JSON
      </pre>
    );
  }

  const tokens = jsonString.split(/(".*?"(?:\s*:)?|\b(?:true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g);

  return (
    <pre className="jsonViewer">
      {tokens.map((token, i) => {
        if (!token) return null;

        let style = { color: '#6a6a6a' }; // default

        if (/^"/.test(token)) {
          style = /:$/.test(token)
            ? { color: '#74c7ec' } // key
            : { color: '#ce9178' }; // string
        } else if (/true|false/.test(token)) {
          style = { color: '#569cd6' };
        } else if (/null/.test(token)) {
          style = { color: '#c586c0' };
        } else if (/^-?\d/.test(token)) {
          style = { color: '#9fba91' };
        }

        return (
          <span key={i} style={style}>
            {token}
          </span>
        );
      })}
    </pre>
  );
};
